module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "selectize-spinner"
  }, [_c('selectize', {
    attrs: {
      "options": _vm.options,
      "labelField": "name",
      "valueField": "id",
      "searchField": "name"
    },
    model: {
      value: (_vm.controller.value),
      callback: function($$v) {
        _vm.$set(_vm.controller, "value", $$v)
      },
      expression: "controller.value"
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6ad4a394", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ad4a394"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/drugStatusSelector/drugStatusSelector.scp.html
// module id = 493
// module chunks = 0